import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import AuthorizedRoute from "./components/AuthorizedRoute";
import KROLoader from "./components/KROLoader";
const Achievements = React.lazy(
  () => import("./pages/achievements/Achievements"),
);
const Dashboard = React.lazy(() => import("./pages/dashboard/Dashboard"));
const Slideshow = React.lazy(() => import("./pages/slideshow/Slideshow"));
const Stories = React.lazy(() => import("./pages/stories/Stories"));
const Users = React.lazy(() => import("./pages/Users/Users"));
const Donors = React.lazy(() => import("./pages/donors/Donors"));
const StoryContent = React.lazy(() => import("./pages/stories/StoryContent"));
const News = React.lazy(() => import("./pages/news/News"));
const NewsContent = React.lazy(() => import("./pages/news/NewsContent"));
const Milestone = React.lazy(() => import("./pages/milestone/Milestone"));
const NewMilestone = React.lazy(() => import("./pages/milestone/NewMilestone"));
const EditMilestone = React.lazy(
  () => import("./pages/milestone/EditMilestone"),
);
const Photos = React.lazy(() => import("./pages/photos/Photos"));
const Album = React.lazy(() => import("./pages/photos/Album"));
const Rfp = React.lazy(() => import("./pages/rfp/Rfp"));
const NewRfp = React.lazy(() => import("./pages/rfp/NewRfp"));
const Jobs = React.lazy(() => import("./pages/jobs/Jobs"));
const Videos = React.lazy(() => import("./pages/videos/Videos"));
const EditRfp = React.lazy(() => import("./pages/rfp/EditRfp"));
const Applications = React.lazy(
  () => import("./pages/applications/Applications"),
);
const Application = React.lazy(
  () => import("./pages/applications/Application"),
);
const EditContent = React.lazy(() => import("./pages/stories/EditContent"));
const EditNewsContent = React.lazy(() => import("./pages/news/EditContent"));

const Router = () => {
  return (
    <Suspense fallback={<KROLoader />}>
      <Routes>
        <Route exact path="/" element={<Dashboard />} />
        {/* Slideshow */}
        <Route
          path="/slideshow"
          element={
            <AuthorizedRoute>
              <Slideshow />
            </AuthorizedRoute>
          }
        />
        {/* Slideshow */}
        <Route
          path="/achievements"
          element={
            <AuthorizedRoute>
              <Achievements />
            </AuthorizedRoute>
          }
        />
        {/* Stories */}
        <Route
          path="/stories"
          element={
            <AuthorizedRoute>
              <Stories />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/storycontent"
          element={
            <AuthorizedRoute>
              <StoryContent />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/editstorycontent"
          element={
            <AuthorizedRoute>
              <EditContent />
            </AuthorizedRoute>
          }
        />
        {/* Stories */}
        {/* Stories */}
        <Route
          path="/news"
          element={
            <AuthorizedRoute>
              <News />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/newscontent"
          element={
            <AuthorizedRoute>
              <NewsContent />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/editnewscontent"
          element={
            <AuthorizedRoute>
              <EditNewsContent />
            </AuthorizedRoute>
          }
        />

        {/* Stories */}
        {/* Stories */}
        <Route
          path="/donors"
          element={
            <AuthorizedRoute>
              <Donors />
            </AuthorizedRoute>
          }
        />
        {/* Stories */}
        {/* Milestone */}
        <Route
          path="/milestone"
          element={
            <AuthorizedRoute>
              <Milestone />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/newmilestone"
          element={
            <AuthorizedRoute>
              <NewMilestone />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/editmilestone"
          element={
            <AuthorizedRoute>
              <EditMilestone />
            </AuthorizedRoute>
          }
        />
        {/* Milestone */}
        {/* Photos */}
        <Route
          path="/photos"
          element={
            <AuthorizedRoute>
              <Photos />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/viewalbum"
          element={
            <AuthorizedRoute>
              <Album />
            </AuthorizedRoute>
          }
        />
        {/* Photos */}
        {/* Videos */}
        <Route
          path="/videos"
          element={
            <AuthorizedRoute>
              <Videos />
            </AuthorizedRoute>
          }
        />
        {/* Videos */}
        {/* RFP */}
        <Route
          path="/rfp"
          element={
            <AuthorizedRoute>
              <Rfp />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/newrfp"
          element={
            <AuthorizedRoute>
              <NewRfp />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/editrfp"
          element={
            <AuthorizedRoute>
              <EditRfp />
            </AuthorizedRoute>
          }
        />
        {/* RFP */}
        {/* JOBS */}
        <Route
          path="/jobs"
          element={
            <AuthorizedRoute>
              <Jobs />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/applications"
          element={
            <AuthorizedRoute>
              <Applications />
            </AuthorizedRoute>
          }
        />
        <Route
          path="/application"
          element={
            <AuthorizedRoute>
              <Application />
            </AuthorizedRoute>
          }
        />

        {/* JOBS */}

        {/* Users */}
        <Route
          path="/users"
          element={
            <AuthorizedRoute>
              <Users />
            </AuthorizedRoute>
          }
        />
        {/* Users */}
      </Routes>
    </Suspense>
  );
};

export default Router;
